/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Wh_BagsInputs */

const en_cargos_wh_bags = /** @type {(inputs: Cargos_Wh_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WH Bags`)
};

const es_cargos_wh_bags = /** @type {(inputs: Cargos_Wh_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolsas almacen`)
};

/**
* | output |
* | --- |
* | "WH Bags" |
*
* @param {Cargos_Wh_BagsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_wh_bags = /** @type {((inputs?: Cargos_Wh_BagsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Wh_BagsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_wh_bags(inputs)
	return es_cargos_wh_bags(inputs)
});